import { createNotification, getAllUsers } from '../services/firebaseService';

// Test function to create a sample notification
export const createTestNotification = async (currentUserId) => {
  try {
    console.log('Creating test notification for user:', currentUserId);
    
    const testNotification = {
      userId: currentUserId,
      type: 'test',
      title: 'Test Notification',
      message: 'This is a test notification to verify the system is working',
      projectId: 'test-project',
      activityId: 'test-activity',
      taskId: 'test-task'
    };
    
    const notificationId = await createNotification(testNotification);
    console.log('Test notification created with ID:', notificationId);
    return notificationId;
  } catch (error) {
    console.error('Error creating test notification:', error);
    throw error;
  }
};

// Test function to check users collection
export const testUsersCollection = async () => {
  try {
    console.log('Testing users collection...');
    const users = await getAllUsers();
    console.log('Users found:', users);
    return users;
  } catch (error) {
    console.error('Error testing users collection:', error);
    throw error;
  }
};

// Add test functions to window for easy access in console
if (typeof window !== 'undefined') {
  window.testNotifications = {
    createTest: createTestNotification,
    testUsers: testUsersCollection
  };
}